/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Listing_ViewsInputs */

const en_seller_dashboard_listing_views = /** @type {(inputs: Seller_Dashboard_Listing_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Views`)
};

const es_seller_dashboard_listing_views = /** @type {(inputs: Seller_Dashboard_Listing_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vistas de Anuncios`)
};

const fr_seller_dashboard_listing_views = /** @type {(inputs: Seller_Dashboard_Listing_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vues de l'annonce`)
};

const de_seller_dashboard_listing_views = /** @type {(inputs: Seller_Dashboard_Listing_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserats-Aufrufe`)
};

const id_seller_dashboard_listing_views = /** @type {(inputs: Seller_Dashboard_Listing_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tayangan Listing`)
};

/** @type {(inputs: Seller_Dashboard_Listing_ViewsInputs) => LocalizedString} */
const ja_seller_dashboard_listing_views = en_seller_dashboard_listing_views;

/** @type {(inputs: Seller_Dashboard_Listing_ViewsInputs) => LocalizedString} */
const zh_seller_dashboard_listing_views = en_seller_dashboard_listing_views;

/** @type {(inputs: Seller_Dashboard_Listing_ViewsInputs) => LocalizedString} */
const ar_seller_dashboard_listing_views = en_seller_dashboard_listing_views;

/** @type {(inputs: Seller_Dashboard_Listing_ViewsInputs) => LocalizedString} */
const it_seller_dashboard_listing_views = en_seller_dashboard_listing_views;

/** @type {(inputs: Seller_Dashboard_Listing_ViewsInputs) => LocalizedString} */
const ru_seller_dashboard_listing_views = en_seller_dashboard_listing_views;

/** @type {(inputs: Seller_Dashboard_Listing_ViewsInputs) => LocalizedString} */
const pt_seller_dashboard_listing_views = en_seller_dashboard_listing_views;

/** @type {(inputs: Seller_Dashboard_Listing_ViewsInputs) => LocalizedString} */
const ko_seller_dashboard_listing_views = en_seller_dashboard_listing_views;

/**
* | output |
* | --- |
* | "Listing Views" |
*
* @param {Seller_Dashboard_Listing_ViewsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_listing_views = /** @type {((inputs?: Seller_Dashboard_Listing_ViewsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Listing_ViewsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_listing_views(inputs)
	if (locale === "es") return es_seller_dashboard_listing_views(inputs)
	if (locale === "fr") return fr_seller_dashboard_listing_views(inputs)
	if (locale === "de") return de_seller_dashboard_listing_views(inputs)
	if (locale === "ja") return ja_seller_dashboard_listing_views(inputs)
	if (locale === "zh") return zh_seller_dashboard_listing_views(inputs)
	if (locale === "ar") return ar_seller_dashboard_listing_views(inputs)
	if (locale === "id") return id_seller_dashboard_listing_views(inputs)
	if (locale === "it") return it_seller_dashboard_listing_views(inputs)
	if (locale === "ru") return ru_seller_dashboard_listing_views(inputs)
	if (locale === "pt") return pt_seller_dashboard_listing_views(inputs)
	return ko_seller_dashboard_listing_views(inputs)
});